import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { AgentFormValues } from "./AgentFormSchema";

type NotificationsTabProps = {
  form: UseFormReturn<AgentFormValues>;
};

const NotificationsTab = ({ form }: NotificationsTabProps) => {
  return (
    <Card>
      <CardContent className="space-y-6">
        <FormField
          control={form.control}
          name="notification_email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Notification Email</FormLabel>
              <FormControl>
                <Input 
                  placeholder="alerts@example.com" 
                  type="email"
                  {...field}
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="notification_webhook_url"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Notification Webhook URL</FormLabel>
              <FormControl>
                <Input 
                  placeholder="https://api.example.com/webhook" 
                  type="url"
                  {...field}
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="text-sm text-muted-foreground">
          <p>Your organization's contact information will be used as the default contact information for this agent.</p>
          <p className="mt-2">You can update your organization's business and contact information in the <Link to="/settings/business" className="text-primary underline">Business Settings</Link>.</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationsTab;
